export function getAuthTokenFromCookie(): string | undefined {
    if (typeof document === 'undefined') {
        return undefined;
    }

    const tokenMatch = document.cookie.match(/(?:^|; )token=([^;]*)/);
    return tokenMatch?.[1] ? decodeURIComponent(tokenMatch[1]) : undefined;
}

export function hasAuthTokenCookie(): boolean {
    return getAuthTokenFromCookie() != null;
}
